import React, { useState, useEffect } from "react";
import { usePageGrid } from "../../../context/PageGridContext";

const FRMNav = ({ tabs, activeTab, onTabChange, activeVessel, showEditDashboard, onMachineChange, selectedMachine }) => {
  const [editOn, setEditOn] = useState(false);
  const [machineData, setMachineData] = useState([]);
  const ctx = usePageGrid();
 const selectedCompanyId = localStorage.getItem("companyid");
  useEffect(() => {
    fetchMachines();
  }, []);

  const fetchMachines = async () => {
    try {
      const res = await  fetch(`https://api.hanoch.in/api/machines/by-company/?id=${selectedCompanyId}`);
      if (res.ok) {
        const data = await res.json();
        setMachineData(data?.data || []);
        console.log("fetched machines",data?.data)
      }
    } catch (err) {
      console.error("Failed to fetch machines:", err);
    }
  };

  const handleEditLayout = () => {
    ctx?.triggerEdit();
    setEditOn(e => !e);
  };

  const handleWidgets = () => {
    ctx?.triggerWidgets();
  };

  return (
    <div className="frm-nav">
      {/* Machine Dropdown — replaces the static "Machines" label */}
      <div className="frm-vessel-sel">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" strokeWidth="2">
          <path d="M19 12H5M12 5l-7 7 7 7"/>
        </svg>

        <select
          value={selectedMachine}
          onChange={(e) => onMachineChange?.(e.target.value)}  // 👈 optional chaining
          style={{
            border: "none",
            background: "transparent",
            fontSize: 13,
            color: "#1a1e2e",
            cursor: "pointer",
            outline: "none",
            paddingRight: 4,
          }}
        >
          <option value="">All Machines</option>
         {(machineData || []).map((m) => (
  <option key={m.id} value={m.id}>
    {m.name}
  </option>
))}
        </select>
      </div>

      {tabs?.map(tab => (
        <div
          key={tab}
          className={`frm-nav-tab${activeTab === tab ? " active" : ""}`}
          onClick={() => onTabChange(tab)}
        >
          {tab}
        </div>
      ))}

      <div className="frm-nav-right">
        <button className="btn-live">
          <span className="dot-live" />
          Live Location
        </button>

        <div className="d-flex align-items-center gap-2 me-2"
          style={{ borderRight: "1px solid #e9ecef", paddingRight: "12px" }}>
          <button
            type="button"
            className={`btn btn-sm ${editOn ? "btn-success" : "btn-outline-secondary"}`}
            style={{ fontSize: 12, padding: "4px 12px", display: "flex", alignItems: "center", gap: 5 }}
            onClick={handleEditLayout}
          >
            <i className={`mdi ${editOn ? "mdi-content-save" : "mdi-pencil-ruler"}`} style={{ fontSize: 14 }} />
            {editOn ? "Save Layout" : "Edit Layout"}
          </button>

          <button
            type="button"
            className="btn btn-sm btn-outline-primary"
            style={{ fontSize: 12, padding: "4px 12px", display: "flex", alignItems: "center", gap: 5 }}
            onClick={handleWidgets}
          >
            <i className="mdi mdi-tune" style={{ fontSize: 14 }} />
            Widgets
          </button>
        </div>
      </div>
    </div>
  );
};

export default FRMNav;